import RecognitionSearchEmployee from "./RecognitionSearchEmployee";

export default RecognitionSearchEmployee;
